import React, { useState } from 'react'
import { experienceData } from '../../data/experienceData'
import './CareerExplorer.css'

const roles = experienceData.filter(role => Number(role.startYear.slice(-4)) >= 2022)

export default function CareerExplorer() {
  const [selected, setSelected] = useState(0)
  const role = roles[selected]
  const followPointer = event => {
    if (event.pointerType !== 'mouse') return
    const bounds = event.currentTarget.getBoundingClientRect()
    event.currentTarget.style.setProperty('--pointer-x', `${event.clientX - bounds.left}px`)
    event.currentTarget.style.setProperty('--pointer-y', `${event.clientY - bounds.top}px`)
  }

  return (
    <aside className="career-explorer" aria-label="Explore my recent career" onPointerMove={followPointer}>
      <div className="explorer-heading"><span className="overline">Career / in focus</span><span>2022 → now</span></div>
      <div className="explorer-track" role="group" aria-label="Choose a company" style={{ '--selected': selected, '--count': roles.length }}>
        <span className="explorer-indicator" aria-hidden="true" />
        {roles.map((item, index) => <button type="button" key={item.id} aria-pressed={selected === index} aria-controls="career-focus" onClick={() => setSelected(index)}><span className="explorer-dot" aria-hidden="true" />{item.company.split(',')[0].replace(' GmbH', '')}</button>)}
      </div>
      <div id="career-focus" className="explorer-focus" aria-live="polite" aria-atomic="true">
        <div className="explorer-content" key={role.id}>
          <div className="explorer-date"><span>{role.startYear} — {role.endYear}</span>{role.current && <span className="explorer-current">Current</span>}</div>
          <h2>{role.company.split(',')[0].replace(' GmbH', '')}</h2>
          <p className="explorer-role">{role.jobtitle}</p>
          <p className="explorer-description">{role.bullets[0]}</p>
          <div className="explorer-technologies">{role.tags.map(tag => <span key={tag}>{tag}</span>)}</div>
        </div>
      </div>
      <div className="explorer-footer"><span>Select a company to explore</span><a href="#experience">Full experience ↗</a></div>
    </aside>
  )
}
